module.exports = __webpack_public_path__ + "static/media/water.6a6b6252.svg";